const mappedEvents = events => {
  return events
    .filter(e => e.payments.assigned !== false) // null is considered as assigned
    .map(e => ({
      data: {
        id: e.eventId,
        encompass: e.encompass,
        additionalData: e.additionalData,
        borrower: e.borrower,
        createdAt: e.createdAt,
        loan: e.loan,
        projectedFees: e.projectedFees,
        property: e.property,
        updatedAt: e.updatedAt,
        deleted: e.deleted,
        payments: e.payments,
        collectedFees: e.collectedFees,
        deductionFees: e.deductionFees
      },
      payroll: {
        id: e.id,
        eventId: e.eventId,
        loanOfficerCompensation: e.payments.amount,
        loanOfficerId: e.payments.employeeId
      }
    }));
};

export default mappedEvents;
